/**
 * Query key factory. Every feature builds its keys from here so cache
 * invalidation stays predictable:
 *
 *   const customerKeys = createQueryKeys('customers');
 *   useQuery({ queryKey: customerKeys.list({ status: 'active' }), ... });
 *   queryClient.invalidateQueries({ queryKey: customerKeys.lists() });
 */
export function createQueryKeys<const TScope extends string>(scope: TScope) {
  return {
    all: [scope] as const,
    lists: () => [scope, 'list'] as const,
    list: <TFilters extends object>(filters: TFilters) => [scope, 'list', filters] as const,
    details: () => [scope, 'detail'] as const,
    detail: (id: string) => [scope, 'detail', id] as const,
  };
}
